import { render } from "./TheA01EarnPointPanel.vue?vue&type=template&id=6a3fd4d8&scoped=true&ts=true"
import script from "./TheA01EarnPointPanel.vue?vue&type=script&lang=ts"
export * from "./TheA01EarnPointPanel.vue?vue&type=script&lang=ts"

import "./TheA01EarnPointPanel.vue?vue&type=style&index=0&id=6a3fd4d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3fd4d8"]])

export default __exports__